import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pin"} maskId="square-filled-radius-0-stroke-1-IconPin"><path d="M14.4007 1.69336L11.1692 7.07927L2.56213 9.76897L8.0429 15.2497L2.7929 20.4997L3.5 21.2068L8.75 15.9568L14.2308 21.4376L16.9205 12.8306L22.3064 9.599L14.4007 1.69336Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPin;
